import api from './api';

export type PublicSignupPayload = {
  empresaNombre: string;
  empresaRut: string;
  adminNombre?: string;
  adminApellido?: string;
  adminEmail: string;
  password: string;
};

export type PublicSignupResponse = {
  empresaId: number;
  empresaNombre: string;
  empresaSlug: string;
  planNombre: string;
  estadoSuscripcion: string;
  adminEmail: string;
  mensaje: string;
};

export const publicService = {
  async signupCompany(payload: PublicSignupPayload): Promise<PublicSignupResponse> {
    const { data } = await api.post('/Public/signup', payload);
    return data;
  },
  async reportarRojo(areaId: number, observaciones?: string, tenantId?: number): Promise<void> {
    await api.post(`/Public/areas/${areaId}/reportar-rojo`, { observaciones }, {
      headers: tenantId ? { 'X-Tenant-Id': String(tenantId) } : undefined,
    });
  },
};
